(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dk-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dk-before-after')) {
    customElements.define('dk-before-after', class extends HTMLElement {
      connectedCallback() {
        const range = this.querySelector('.dk-ba__range');
        if (!range) return;
        const update = () => this.style.setProperty('--pos', range.value + '%');
        range.addEventListener('input', update);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dk-clock"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dk-clock')) {
    customElements.define('dk-clock', class extends HTMLElement {
      connectedCallback() {
        this.out = this.querySelector('[data-time]'); this.bar = this.querySelector('.dk-clock__bar span');
        const steps = [...this.querySelectorAll('.dk-clock__step')]; if (!steps.length) return;
        this.max = Math.max(...steps.map((s) => +s.dataset.min || 0)) || 15; this.cur = 0;
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { if (e.isIntersecting) { steps.forEach((s) => s.classList.toggle('is-active', s === e.target)); this.go(+e.target.dataset.min || 0); } });
        }, { rootMargin: '-45% 0px -45% 0px' });
        steps.forEach((s) => io.observe(s));
      }
      go(target) {
        cancelAnimationFrame(this.raf); const from = this.cur, t0 = performance.now(), d = 700;
        const tick = (t) => { const k = Math.min(1, (t - t0) / d); const v = from + (target - from) * k; this.cur = v;
          const total = Math.round(v * 60), mm = String(Math.floor(total / 60)).padStart(2, '0'), ss = String(total % 60).padStart(2, '0');
          this.out.textContent = mm + ':' + ss; this.bar.style.setProperty('--p', (v / this.max * 100) + '%'); this.bar.style.width = (v / this.max * 100) + '%';
          if (k < 1) this.raf = requestAnimationFrame(tick); };
        this.raf = requestAnimationFrame(tick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dk-hotspots"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dk-hotspots')) {
    customElements.define('dk-hotspots', class extends HTMLElement {
      connectedCallback() {
        this.picked = new Map();
        this.fmt = new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
        this.querySelectorAll('.dk-pin').forEach((pin) => pin.addEventListener('click', () => this.show(pin)));
        this.querySelectorAll('[data-toggle]').forEach((b) => b.addEventListener('click', () => this.toggle(b)));
        this.querySelector('[data-addall]').addEventListener('click', () => this.addAll());
        const first = this.querySelector('.dk-pin'); if (first) this.show(first);
      }
      show(pin) {
        this.querySelectorAll('.dk-pin').forEach((p) => p.setAttribute('aria-pressed', p === pin));
        this.querySelectorAll('.dk-hs__card').forEach((c) => c.classList.toggle('is-active', c.id === pin.dataset.target));
        this.querySelector('[data-empty]').hidden = true;
      }
      toggle(b) {
        const id = b.dataset.variant;
        if (this.picked.has(id)) { this.picked.delete(id); b.textContent = 'Añadir al setup'; }
        else { this.picked.set(id, { price: +b.dataset.price, title: b.dataset.title }); b.textContent = 'Quitar del setup'; }
        const pin = this.querySelector('[data-target="' + b.dataset.pin + '"]'); if (pin) pin.classList.toggle('is-added', this.picked.has(id));
        this.render();
      }
      render() {
        let t = 0; const list = this.querySelector('[data-list]'); list.innerHTML = '';
        this.picked.forEach((v) => { t += v.price; const li = document.createElement('li'); li.innerHTML = '<span></span><span>' + this.fmt.format(v.price / 100) + '</span>'; li.firstChild.textContent = v.title; list.appendChild(li); });
        this.querySelector('[data-total]').textContent = this.fmt.format(t / 100);
        this.querySelector('[data-count]').textContent = this.picked.size + ' / ' + this.querySelectorAll('.dk-pin').length;
        this.querySelector('[data-addall]').disabled = this.picked.size === 0;
      }
      async addAll() {
        const btn = this.querySelector('[data-addall]'); btn.disabled = true; btn.setAttribute('aria-busy', 'true');
        const items = [...this.picked.keys()].map((id) => ({ id: +id, quantity: 1 }));
        try {
          const r = await fetch(this.dataset.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          if (!r.ok) throw new Error();
          window.location.href = this.dataset.cart;
        } catch (e) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = 'No se pudo añadir. Inténtalo de nuevo'; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dk-lab-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dk-lab')) {
    customElements.define('dk-lab', class extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.dk-switch');
        this.btn.addEventListener('click', () => this.set(!this.classList.contains('is-order')));
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.auto === 'true' && !this.reduce && 'IntersectionObserver' in window) {
          const io = new IntersectionObserver((e) => { if (e[0].isIntersecting) { io.disconnect(); setTimeout(() => this.set(true), 1400); } }, { threshold: .5 });
          io.observe(this);
        }
      }
      set(on) {
        this.classList.toggle('is-order', on);
        this.btn.setAttribute('aria-pressed', on);
        const c = this.querySelector('[data-mode-label]'); if (c) c.textContent = on ? c.dataset.b : c.dataset.a;
        this.querySelectorAll('[data-from]').forEach((el) => {
          const a = parseFloat(on ? el.dataset.from : el.dataset.to), b = parseFloat(on ? el.dataset.to : el.dataset.from);
          if (isNaN(a) || isNaN(b) || this.reduce) { el.textContent = on ? el.dataset.to : el.dataset.from; return; }
          const t0 = performance.now(), d = 900;
          const tick = (t) => { const k = Math.min(1, (t - t0) / d); el.textContent = Math.round(a + (b - a) * k); if (k < 1) requestAnimationFrame(tick); };
          requestAnimationFrame(tick);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dk-modes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dk-modes')) {
    customElements.define('dk-modes', class extends HTMLElement {
      connectedCallback() {
        const tabs = [...this.querySelectorAll('.dk-modes__tab')];
        const panels = [...this.querySelectorAll('.dk-modes__panel')];
        tabs.forEach((t) => t.addEventListener('click', () => {
          const i = +t.dataset.i;
          tabs.forEach((x, k) => { x.classList.toggle('is-active', k === i); x.setAttribute('aria-selected', k === i); });
          panels.forEach((x, k) => x.classList.toggle('is-active', k === i));
        }));
        this.querySelectorAll('.dk-modes__add').forEach((b) => b.addEventListener('click', async () => {
          const items = b.dataset.ids.split(',').filter(Boolean).map((id) => ({ id: +id, quantity: 1 }));
          b.disabled = true; b.textContent = 'Añadiendo…';
          try {
            await fetch(this.dataset.cart + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
            const code = b.dataset.code;
            window.location.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(this.dataset.cartUrl) : this.dataset.cartUrl;
          } catch (e) { b.disabled = false; b.textContent = 'Inténtalo de nuevo'; }
        }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dk-stage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dk-stage')) {
    customElements.define('dk-stage', class extends HTMLElement {
      connectedCallback() {
        this.i = 0;
        this.slides = [...this.querySelectorAll('.dk-stage__slide')];
        this.infos = [...this.querySelectorAll('.dk-stage__info')];
        this.chips = [...this.querySelectorAll('.dk-stage__chip')];
        this.ms = parseInt(this.dataset.interval || '6000', 10);
        this.chips.forEach((c) => c.addEventListener('click', () => { this.go(+c.dataset.i); this.restart(); }));
        this.dn = this.querySelector('.dk-daynight');
        this.manual = false;
        this.querySelectorAll('.dk-daynight__opt').forEach((b) => b.addEventListener('click', () => { this.manual = true; this.mode(b.dataset.mode); }));
        this.go(0);
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.restart());
        this.style.setProperty('--dk-dur', this.ms + 'ms');
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.restart();
      }
      go(n) {
        this.i = (n + this.slides.length) % this.slides.length;
        const set = (arr) => arr.forEach((el, k) => el.classList.toggle('is-active', k === this.i));
        set(this.slides); set(this.infos); set(this.chips);
        this.chips.forEach((c, k) => c.setAttribute('aria-selected', k === this.i));
        this.syncDN();
        if (!this.manual) {
          this.mode('day');
          clearTimeout(this.nt);
          if (this.slides[this.i].classList.contains('has-night')) this.nt = setTimeout(() => { if (!this.manual) this.mode('night'); }, this.ms / 2);
        }
        const g = this.slides[this.i].dataset.glow;
        if (g) this.style.setProperty('--glow', g);
      }
      mode(m) {
        this.classList.toggle('is-night', m === 'night');
        this.querySelectorAll('.dk-daynight__opt').forEach((b) => b.classList.toggle('is-on', b.dataset.mode === m));
      }
      syncDN() { if (this.dn) this.dn.hidden = !this.slides[this.i].classList.contains('has-night'); }
      stop() { clearInterval(this.t); this.classList.add('is-paused'); }
      restart() {
        clearInterval(this.t); this.classList.remove('is-paused');
        if (this.slides.length > 1) this.t = setInterval(() => this.go(this.i + 1), this.ms);
      }
      disconnectedCallback() { clearInterval(this.t); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
